import { find, propEq } from "ramda";
import blacklistedSpecifications from "../enums/blacklistedSpecifications";

export const findColorAttribute = find(propEq("Name", "Color"));

export const getProductDisplaySpecifications = product => {
    const originalSpecs = product.Specifications;
    return Object.keys(originalSpecs)
        .filter(obj => !blacklistedSpecifications.includes(obj))
        .reduce((res, key) => {
            res[key] = originalSpecs[key];
            return res;
        }, {});
};
